import React, { useContext, useEffect, useState } from "react";

import { Menu, MenuProps, Typography } from "antd";
import classes from "./Styles/ConsumerDashboardMenu.module.css";
import { AuthOperation } from "constants/common";
import {
	MenuUnfoldOutlined,
	BorderOuterOutlined,
	LogoutOutlined,
	FileTextOutlined,
} from "@ant-design/icons";
import { useRouterContext } from "@refinedev/core";
import { getAllDocuments } from "api/admin";

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
	label: React.ReactNode,
	key?: React.Key | null,
	icon?: React.ReactNode,
	children?: MenuItem[]
): MenuItem {
	return {
		key,
		icon,
		children,
		label,
	} as MenuItem;
}

const NavComponent: React.FC<{ text: string }> = ({ text }) => (
	<Typography.Text ellipsis style={{ verticalAlign: "center" }}>
		{text}
	</Typography.Text>
);

const SubNavComponent: React.FC<{ text: string }> = ({ text }) => (
	<Typography.Text
		ellipsis
		style={{ verticalAlign: "center" }}
		rootClassName={classes.subNavText}
	>
		{text}
	</Typography.Text>
);

const items = (docs: any[]): MenuItem[] => [
	{ type: "divider" },
	getItem(<NavComponent text="Jobs Overview" />, "1", <MenuUnfoldOutlined />),
	getItem(<NavComponent text="Playground" />, "2", <BorderOuterOutlined />),
	{ type: "divider" },
	docs.length > 0
		? getItem(
				<NavComponent text="Documentation" />,
				"doc",
				<FileTextOutlined style={{ marginLeft: "3px" }} />,
				[
					...docs.map((doc, index) =>
						getItem(
							<SubNavComponent text={doc.title} />,
							`doc__${doc.id}`
						)
					),
				]
			)
		: getItem(
				<NavComponent text="Documentation" />,
				"new-doc",
				<FileTextOutlined />
			),
	getItem(<NavComponent text="Logout" />, "4", <LogoutOutlined />),
];

interface IProps {
	handleClick: (key: string) => void;
}

export const ConsumerDashboardMenu: React.FC<IProps> = ({ handleClick }) => {
	const { useLocation } = useRouterContext();

	const { pathname } = useLocation();

	const [selectedKey, setSelectedKey] = useState("1");

	useEffect(() => {
		if (pathname.includes("playground")) {
			setSelectedKey("2");
		} else if (pathname.includes("jobs")) {
			setSelectedKey("1");
		} else if (pathname.includes("documentation/1")) {
			setSelectedKey("3");
		} else if (pathname.includes("documentation/2")) {
			setSelectedKey("6");
		} else if (pathname.includes("documentation/3")) {
			setSelectedKey("7");
		} else {
			setSelectedKey("5");
		}
	}, [pathname]);

	const [docs, setDocs] = useState([]);
	useEffect(() => {
		(async () => {
			const res = await getAllDocuments();
			setDocs(res.data);
		})();
	}, []);

	return (
		<Menu
			mode="inline"
			theme="dark"
			selectedKeys={[selectedKey]}
			items={items(docs)}
			onClick={(e) => handleClick(e.key)}
		/>
	);
};
